import React from "react";
import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <Nav />
      <main
        id="main"
        className="min-h-[70vh] flex items-center px-6 md:px-10 pt-32"
        data-testid="not-found"
      >
        <div className="max-w-[1120px] mx-auto w-full">
          <div className="tick mb-4 text-[#9a3412]">404 · No such page</div>
          <h1 className="font-serif-display text-5xl md:text-7xl text-[#171717] leading-[1.02] max-w-3xl">
            That page isn't on file.
          </h1>
          <p className="mt-6 font-mono-tech text-[13px] text-[#525252] max-w-md leading-relaxed">
            The link may be stale, or the briefing it pointed to was never created.
            Report links look like <span className="text-[#171717]">/report/&lt;id&gt;</span>.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-3">
            <Link to="/" className="btn-primary" data-testid="not-found-home">
              Back to home <ArrowRight size={14} />
            </Link>
            <a href="/#intake" className="btn-secondary" data-testid="not-found-sweep">
              Run a free sweep
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
